import { createShortcut, Node_Type } from 'ricos-types';
import { DEFAULTS } from './defaults.js';
import { getAddButtons } from './getAddButtons.js';
import { getTextButtons } from './getTextButtons.js';
import { tiptapExtensions } from './tiptap.js';
import { CODE_BLOCK_TYPE } from './types.js';
import 'wix-rich-content-editor-common';
import './icons/CodeBlockIcon.js';
import 'react';
import 'wix-rich-content-common';
import 'wix-rich-content-toolbars-v3/libs/resolvers-ids';
import './icons/toolbars-v3/CodeBlockIcon.js';
import '@tiptap/pm/state';
import 'ricos-schema';
import 'ricos-schema/dist/statics/code_block.defaults.json';
import 'wix-rich-content-plugin-commons';
import './dataHooks.js';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
const pluginCodeBlock = (config) => {
  const pluginConfig = __spreadValues(__spreadValues({}, DEFAULTS.config), config);
  return {
    config: pluginConfig,
    type: CODE_BLOCK_TYPE,
    shortcuts: [
      createShortcut({
        name: Node_Type.CODE_BLOCK,
        description: "ShortcutsSheet_Formatting_CodeBlock",
        keys: { macOs: "Meta+Shift+C", windows: "Ctrl+Shift+C" },
        command({ editorCommands }) {
          editorCommands.setBlockType(CODE_BLOCK_TYPE);
        },
        group: "ShortcutsSheet_Section_Formatting",
        enabled: true
      })
    ],
    getAddButtons: (config2, services) => getAddButtons(),
    tiptapExtensions,
    textButtons: getTextButtons()
  };
};

export { pluginCodeBlock };
//# sourceMappingURL=editor.js.map
